function TokenService (apiInstance) 
{
	const api = apiInstance;

	this.checkExistance = (type, token) => {
		return api.request('HEAD', {}, '/users/token/' + type + '/' + token, {});
	}

	this.use = (type, token, userParams = {}) => {
		return api.request('POST', userParams, '/users/token/' + type + '/' + token, {});
	}

	return this;
}

export default TokenService;


// WEBPACK FOOTER //
// ./src/Services/TokenService.js